import type { IconSvgObject } from './types';

const AbsoluteIcon: IconSvgObject = [
  ["path", { d: "M18.5 3L20 3.00001C21.1046 3.00002 22 3.89545 22 5.00001V19C22 20.1046 21.1046 21 20 21H18.5M5.5 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 8H8.76393C9.52148 8 10.214 8.428 10.5528 9.10557L13.4472 14.8944C13.786 15.572 14.4785 16 15.2361 16H16.5M17 8H16.4075C15.8308 8 15.2822 8.24896 14.9024 8.68299L9.09762 15.317C8.71784 15.751 8.16919 16 7.59246 16H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AbsoluteIcon;
